<div class="col-md-12 main-heading">
    <div class="d-flex">
        <a routerLink="/index">
            <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
        </a>
        <div class="caption-heading">Park & Fly Bookings Live</div>
    </div>
</div>
<div class="col-md-12 pagecustom">
    <div class="page-wrapper" >
        <div class="row main-container boxscroll">
            <div class="block-section full-table">
                <div class="heading-m">
                    <div class="caption">
                        <img src="assets/images/pages-icon/live_events.png">Current Bookings 
                        
                    </div>
                </div>
                <div class="list-sidebar" style="overflow-y: auto;">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Tag No</th>
                                <th>Vehicle Number</th>
                                <th>Booking Number</th>
                               <th>Booking Date</th>
                                <th>Checkin Date</th>
                                <th>Checkout Date</th>
                                <th>Total Amount</th>
                                <th>Ticket No</th>
                                <th>Entry Time</th>
                                <th>Exit Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eve of dataList"
                            [ngStyle]="setRowStyles(eve)">
                                <td nowrap="yes">{{eve.TAG_NO}}</td>
                                <td nowrap="yes">{{eve.VEHICLE_NUMBER}}</td>
                                <td nowrap="yes">{{eve.BOOKING_NUMBER}}</td>
                                <td nowrap="yes">{{eve.BOOKING_DATE}}</td>
                                <td nowrap="yes">{{eve.CHECKIN_DATE}}</td>
                                <td nowrap="yes">{{eve.CHECKOUT_DATE}}</td>
                                <td nowrap="yes">{{eve.TOTAL_AMOUNT}}</td>
                                <td nowrap="yes">{{eve.TICKET_NO}}</td>
                                <td nowrap="yes">{{eve.ENTRY_DATETIME}}</td>
                                <td nowrap="yes">{{eve.EXIT_DATETIME}}</td>
                                
                            </tr>
                             
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>